import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { EmployerT4ListColumns, T4SummaryListColumns } from "../../appconfig/DatatableSetting";
import { getAllDetails, getThreeDetailsByIdParam, postSingleData } from "../../service/ProductService";
import { T4_REPORT_LIST, T4_SUMMARY } from "../../config/ApiConstant";
import { employeeT4NameTemplate } from "../../appconfig/TemplateFieldSetting";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import { payrollNumberValidate } from "../../config/Validate";
import { InputText } from "primereact/inputtext";

const EmployerT4Payroll = () => {
  document.title = "T4 Summary | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);
  const [t4List, setT4List] = useState<any>([]);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [addDeleteT4Dialog, setAddDeleteT4Dialog] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [summaryNumber, setSummaryNumber] = useState<any>({});

  // filters
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";

  // const clientId = client_id?.id

  const { id }: any = useParams();

  const clientId = id ? atob(id) : null;

  // useefect for get user list
  useEffect(() => {
    getListEmployee();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear]);

  // list-employee
  const getListEmployee = async () => {
    try {
      let idToSend = null;
      let emp_id = null;

      if (userRole === "Client") {
        idToSend = userData?.id;
      } else if (userRole === "Employee") {
        emp_id = userData?.id;
      } else {
        idToSend = clientId;
      }

      const response = await getAllDetails(`${T4_REPORT_LIST}?id=${idToSend}&emp_id=${emp_id}&year=${selectedYear}&type=Summary`);

      const data = response;

      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // add edit dialog
  const t4Dialog = async () => {
    setAddDeleteT4Dialog(true);
  };

  // submit T4 dialog
  const submitT4Form = async () => {
    const { isError, errors } = payrollNumberValidate(summaryNumber);
    setErrors(errors);
    if (isError) return;
    setSubmitLoading(true);
    try {
      let clientIdToUse = null;
      if (userRole === "User") {
        clientIdToUse = clientId;
      } else if (userRole === "Client") clientIdToUse = userData?.id;

      const payrollno = summaryNumber?.payroll_no;

      const response = await postSingleData(`${T4_SUMMARY}/${clientIdToUse}?payroll_no=${payrollno}&year=${selectedYear}`);

      if (response) {
        setT4List(response?.data || []);
        setPageLoad(true);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditT4Dialog();
        getListEmployee();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // on Input change

  const onInputChange = (e: any, name: string) => {
    let val = null;
    val = e?.target?.value ?? e?.value;

    setSummaryNumber({ ...summaryNumber, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // hide add & edit t4 modal
  const hideAddEditT4Dialog = () => {
    setAddDeleteT4Dialog(false);
    setSubmitLoading(false);
    setSummaryNumber({});
  };

  // clear all filter
  const clearAll = () => {
    setSelectedYear(currentYear);
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      {/* <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span> */}
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          {/* <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-3 p-button-outlined common-p-outline-button" /> */}

          <Calendar
            id="year"
            value={moment(selectedYear, "YYYY").toDate()}
            onChange={(e) => {
              const selectedDate = e.value;
              if (selectedDate instanceof Date) {
                const year = moment(selectedDate).year();
                setSelectedYear(year);
              }
            }}
            view="year"
            dateFormat="yy"
            showIcon
            placeholder="Filter by year"
            className="mr-2 w-15rem"
          />

          <Button className="ml-1 common-primary-button mr-3" icon="pi pi-plus" label="Generate T4 Summary" onClick={() => t4Dialog()} />
        </>
      )}
    </div>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.t4_url) {
      window.open(rowData?.t4_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  return (
    <>
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " T4 Reports"}
                emptyMessage="No T4 Summary Found"
                removableSort
              >
                {T4SummaryListColumns.map((col, i) => {
                  if (col.field === "t4_url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {T4SummaryListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Generate t4 dialog */}
      <Dialog
        visible={addDeleteT4Dialog}
        style={{ width: "600px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Generate T4 Summary"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditT4Dialog} disabled={submitLoading} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={submitT4Form} loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditT4Dialog}
      >
        <h4 className="mb-4">Do you want to generate T4 Summary ? </h4>
        <div className="grid p-fluid formgrid">
          <label htmlFor="payroll_no" className="flex align-items-center justify-content-center">
            Payroll Number *
          </label>
          <div className="field col-12 md:col-6 mb-0">
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <InputText
                  id="payroll_no"
                  value={summaryNumber.payroll_no || ""}
                  onChange={(e) => onInputChange(e, "payroll_no")}
                  placeholder="Enter Payroll Number"
                  className={errors["payroll_no"] && "p-invalid"}
                  keyfilter={"num"}
                />
              </div>
            </form>

            <small className="p-invalid-txt">{errors["payroll_no"]}</small>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default EmployerT4Payroll;
